/// <amd-module name="Dashboards/DashboardView/src/model/Widget" />
import { DeepReadonly } from "./DeepReadonly";

import { DashboardWidgetProps } from "Dashboards/WidgetContracts/Internal/DashboardWidgetProps";

/** A widget that cannot be modified */
export interface Widget extends DeepReadonly<DashboardWidgetProps> {}
